// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__GEKz7","flex":"Portfolio_flex__PxnX+","imgPort":"Portfolio_imgPort__KkDrC","overlay":"Portfolio_overlay__Nn0Qn"};